export default __webpack_public_path__ + "static/media/category-1.fd83ffbc.svg";